import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Legend, Tooltip } from 'recharts';
import Icon from '../../../components/AppIcon';

const SafetyAuditPerformance = ({ data, scoreData }) => {
  const COLORS = {
    'Excellent': 'var(--color-success)',
    'Good': 'var(--color-accent)',
    'Satisfactory': 'var(--color-warning)',
    'Needs Improvement': 'var(--color-error)'
  };

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
          <p className="text-sm font-semibold text-foreground">{payload?.[0]?.name}</p>
          <p className="text-xs text-muted-foreground">
            Count: <span className="font-medium">{payload?.[0]?.value}</span>
          </p>
        </div>
      );
    }
    return null;
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {scoreData?.map((score, index) => (
          <div 
            key={index}
            className="bg-card border border-border rounded-lg p-4"
          >
            <div className="flex items-center justify-between mb-3">
              <div className="flex items-center gap-2">
                <div 
                  className="w-10 h-10 rounded-lg flex items-center justify-center"
                  style={{ backgroundColor: `${score?.color}20` }}
                >
                  <Icon name={score?.icon} size={20} color={score?.color} />
                </div>
                <div>
                  <p className="text-xs text-muted-foreground">{score?.label}</p>
                  <p className="text-xl font-bold text-foreground">{score?.value}</p>
                </div>
              </div>
              <div className={`px-2 py-1 rounded-full text-xs font-medium ${
                score?.trend === 'up' ?'bg-success/10 text-success' :'bg-error/10 text-error'
              }`}>
                <Icon name={score?.trend === 'up' ? 'TrendingUp' : 'TrendingDown'} size={12} />
              </div>
            </div>
            <div className="space-y-1">
              <div className="flex justify-between text-xs">
                <span className="text-muted-foreground">Progress</span>
                <span className="text-foreground font-medium">{score?.progress}%</span>
              </div>
              <div className="w-full bg-muted rounded-full h-2">
                <div 
                  className="h-2 rounded-full transition-all duration-300"
                  style={{ 
                    width: `${score?.progress}%`,
                    backgroundColor: score?.color
                  }}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
      <div className="bg-muted/30 border border-border rounded-lg p-4">
        <h4 className="text-sm font-semibold text-foreground mb-4">Audit Score Distribution</h4>
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              labelLine={false}
              outerRadius={90}
              fill="#8884d8"
              dataKey="value"
              label={({ name, percent }) => `${name}: ${(percent * 100)?.toFixed(0)}%`}
            >
              {data?.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS?.[entry?.name]} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
            <Legend 
              verticalAlign="bottom" 
              height={36}
              wrapperStyle={{ color: 'var(--color-foreground)' }}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};

export default SafetyAuditPerformance;